import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import JavneNabavke from '../views/JavneNabavke.vue'
import Vesti from '../views/Vesti.vue'
import Cenovnici from '../views/Cenovnici.vue'
import Programi from '../views/Programi.vue'
import Izvestaji from '../views/Izvestaji.vue'
import Organizacija from '../views/Organizacija.vue'
import Automati from '../views/Automati.vue'
import ZoneParkiranja from '../views/ZoneParkiranja.vue'
import UklonjenaVozila from '../views/UklonjenaVozila.vue'
import ResursForma from '../views/ResursForma.vue'
import ResursDetalji from '../views/ResursDetalji.vue'
import DnevnaParkingKarta from '../views/DnevnaParkingKarta.vue'
import MesecnaPretplata from '../views/MesecnaPretplata.vue'
import Kupovina from '../views/Kupovina.vue'
import UsloviKupovine from '../views/UsloviKupovine.vue'
import KorpaView from '../views/KorpaView.vue'
import PaymentTest from '../views/PaymentTest.vue'
import Placanje from '../views/Placanje.vue'
import PlacanjeSacuvaj from '../views/PlacanjeSacuvaj.vue'
import PlacanjeStatus from '../views/PlacanjeStatus.vue'

import store from '@/store' // <--- Include our store
//import VueProgressBar from 'vue-progressbar'
import app from '../main' // import the instance

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/vesti',
    name: 'Vesti',
    component: Vesti,
    //props: true,
    beforeEnter(to, from, next) {
      console.log('beforeEnter')
      store
        .dispatch('resursi/dajResurse', {
          type: 'vest',
          perPage: store.state.perPage,
          page: 1,
          filters: store.state.filters
        })
        .then(() => {
          next()
        })
    }
    // beforeUpdate(to, from, next) {
    //   console.log('beforeUpdate')
    //   store
    //     .dispatch('resursi/dajResurse', {
    //       type: 'vest',
    //       perPage: store.state.perPage,
    //       page: store.state.resursi.page,
    //       filters: store.state.filters
    //     })
    //     .then(() => {
    //       next()
    //     })
    // }
  },
  {
    path: '/javne-nabavke',
    name: 'JavneNabavke',
    component: JavneNabavke,
    beforeEnter(to, from, next) {
      store
        .dispatch('resursi/dajResurse', {
          type: 'javna-nabavka',
          perPage: store.state.perPage,
          page: 1,
          filters: store.state.filters
        })
        .then(() => {
          next()
        })
    }
  },
  {
    path: '/cenovnici',
    name: 'Cenovnici',
    component: Cenovnici,
    beforeEnter(to, from, next) {
      store
        .dispatch('resursi/dajResurse', {
          type: 'cenovnik',
          perPage: store.state.perPage,
          page: 1,
          filters: store.state.filters
        })
        .then(() => {
          next()
        })
    }
  },
  {
    path: '/programi',
    name: 'Programi',
    component: Programi,
    beforeEnter(to, from, next) {
      store
        .dispatch('resursi/dajResurse', {
          type: 'program',
          perPage: store.state.perPage,
          page: store.state.page,
          filters: store.state.filters
        })
        .then(() => {
          next()
        })
    }
  },
  {
    path: '/izvestaji',
    name: 'Izvestaji',
    component: Izvestaji,
    beforeEnter(to, from, next) {
      store
        .dispatch('resursi/dajResurse', {
          type: 'izvestaj',
          perPage: store.state.perPage,
          page: store.state.page,
          filters: store.state.filters
        })
        .then(() => {
          next()
        })
    }
  },
  {
    path: '/organizacija',
    name: 'Organizacija',
    component: Organizacija,
    beforeEnter(to, from, next) {
      store
        .dispatch('resursi/dajResurse', {
          type: 'organizacija',
          perPage: store.state.perPage,
          page: store.state.page,
          filters: store.state.filters
        })
        .then(() => {
          next()
        })
    }
  },
  {
    path: '/automati',
    name: 'Automati',
    component: Automati
  },
  {
    path: '/zone-parkiranja',
    name: 'ZoneParkiranja',
    component: ZoneParkiranja
  },
  {
    path: '/uklonjena-vozila',
    name: 'UklonjenaVozila',
    component: UklonjenaVozila
  },
  {
    //path: '/resurs-forma',
    path: '/resurs-forma/:id?', // ? - optional param
    name: 'ResursForma',
    component: ResursForma,
    props: true,
    beforeEnter(to, from, next) {
      if (to.params.id) {
        store.dispatch('resursi/dajResurs', to.params.id).then(() => {
          next()
        })
      } else {
        next()
      }
    }
  },
  {
    //path: '/resurs-forma',
    path: '/resurs-detalji/:id?', // ? - optional param
    name: 'ResursDetalji',
    component: ResursDetalji,
    props: true,
    beforeEnter(to, from, next) {
      if (to.params.id) {
        store.dispatch('resursi/dajResurs', to.params.id).then(() => {
          next()
        })
      } else {
        next()
      }
    }
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
  {
    path: '/dnevna-parking-karta',
    name: 'DnevnaParkingKarta',
    component: DnevnaParkingKarta
  },
  {
    path: '/mesecna-pretplata',
    name: 'MesecnaPretplata',
    component: MesecnaPretplata
  },
  {
    path: '/korpa',
    name: 'KorpaView',
    component: KorpaView
  },
  {
    path: '/kupovina',
    name: 'Kupovina',
    component: Kupovina,
    props: true
  },
  {
    path: '/uslovi-kupovine',
    name: 'UsloviKupovine',
    component: UsloviKupovine
  },
  {
    path: '/payment-test',
    name: 'PaymentTest',
    component: PaymentTest
  },
  {
    path: '/placanje',
    name: 'Placanje',
    component: Placanje
  },
  {
    path: '/placanje-sacuvaj',
    name: 'PlacanjeSacuvaj',
    component: PlacanjeSacuvaj
  },
  {
    path: '/placanje-status',
    name: 'PlacanjeStatus',
    component: PlacanjeStatus,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  //console.log('beforeEach')
  //console.log(to.query)
  if (app) {
    app.$Progress.start()
  }
  next()
})

router.afterEach(() => {
  if (app) {
    app.$Progress.finish()
  }
})

export default router
